export const formatDecimal = value => {
    return value.replace(/[^0-9,.]/g, "").replace(",", ".");
};
